import React from 'react';

export const ConventionHeroKpi = ({ label, value, icon: Icon, accent }) => (
  <div className={`rounded-lg bg-gradient-to-br ${accent} backdrop-blur-sm p-3 border border-white/10`}>
    <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-wider text-blue-100 font-semibold">
      <Icon className="w-3 h-3" />
      <span className="truncate">{label}</span>
    </div>
    <div className="text-2xl font-bold mt-0.5 tabular-nums text-white">{value}</div>
  </div>
);

const STAT_COLORS = {
  emerald: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  amber: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
  rose: { bg: 'bg-rose-50', text: 'text-rose-700', border: 'border-rose-200' },
  slate: { bg: 'bg-slate-50', text: 'text-slate-700', border: 'border-slate-200' },
};

export const ConventionCellStat = ({ color, value, label }) => {
  const c = STAT_COLORS[color] || STAT_COLORS.slate;
  return (
    <div className={`text-center ${c.bg} border ${c.border} rounded-lg py-2 px-1`}>
      <div className={`text-2xl font-bold tabular-nums ${c.text}`}>{value}</div>
      <div className="text-[10px] uppercase tracking-wider text-slate-600 font-semibold mt-0.5">{label}</div>
    </div>
  );
};

